import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=01b9bf68&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports